import React from "react";
import PropTypes from "prop-types";

export default function StatCard({ label, count, danger = false }) {
  return (
    <div className="flex-1 bg-white border border-gray-200 rounded-xl p-5">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">{label}</p>
      <p className={`text-md font-bold ${danger ? "text-red-500" : "text-slate-900"}`}>{count}</p>
    </div>
  );
}

StatCard.propTypes = {
  label:  PropTypes.string.isRequired,
  count:  PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  danger: PropTypes.bool,
};
